module.exports = __webpack_public_path__ + "img/photosession_1_14.89770dc5.jpg";